import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
    }),
  };

  get<T>(url: string, headers?: HttpHeaders): Observable<T> {
    const options = {
      headers: headers || this.httpOptions.headers,
    };
    return this.http.get<T>(url, options).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getById<T>(url: string, id: string | number, params?: any): Observable<T> {
    const options = { ...this.httpOptions, params };
    return this.http.get<T>(`${url}/${id}`, options).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  post<T>(url: string, body: any, options?: HttpHeaders): Observable<T> {
    return this.http.post<T>(url, body, { headers: options || this.httpOptions.headers }).pipe(
      catchError(this.handleError)
    );
  }

  postFile<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    const options = headers ? { headers } : {};
    return this.http.post<T>(url, body, options).pipe(
      catchError(this.handleError)
    );
  }

  put<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(url, body, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  patch<T>(url: string, id: string | number, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.patch<T>(`${url}/${id}`, body, {
      headers: headers || this.httpOptions.headers
    }).pipe(
      catchError(this.handleError)
    );
  }

  delete<T>(url: string, id?: string | number): Observable<T> {
    const targetUrl = id != null ? `${url}/${id}` : url;
    return this.http.delete<T>(targetUrl, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }



  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Server error (code: ${error.status}): ${error.message}`;
      if (error.error && error.error.message) {
        // Preserve the actual API error message
        errorMessage = error.error.message;
      }
    }
    console.error(errorMessage);
    // Return the actual error response instead of a generic message
    return throwError(() => error);
  }

}
